module.exports = __webpack_public_path__ + "static/media/paint-brush-alt.9afade4f.svg";